import Mark from 'mark.js';

export default class Highlight {
    constructor() {
        const queryString = window.location.search;
        const urlParams = new URLSearchParams(queryString);
        let mark = urlParams.get('mark');
        if (mark && mark.length > 0) {
            var context = document.querySelector('.wrapper');
            var instance = new Mark(context);
            instance.mark(mark);
            // if no scroll, we move to mark
            let section = urlParams.get('section');
            if (!section) {
                window.find(mark);
                if (window.getSelection) {
                    if (window.getSelection().empty) {
                        // Chrome
                        window.getSelection().empty();
                    } else if (window.getSelection().removeAllRanges) {
                        // Firefox
                        window.getSelection().removeAllRanges();
                    }
                } else if (document.selection) {
                    // IE?
                    document.selection.empty();
                }
            }
        }
    }
}
